/* Petal Green – Product Landing Purple
 * Behaviour: gallery, pack selection, addon toggle, accordions, stat ring reveal + count-up.
 *
 * Pack/addon/accordion handlers use event delegation so they keep working
 * even when Shopify's theme editor re-renders blocks. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var page = document.querySelector('.petal-page');
    if (!page) return;

    /* ---------- Pack selection (event-delegated) ---------- */
    page.addEventListener('click', function (e) {
      // Don't change pack selection when the click was on the addon checkbox.
      if (e.target.closest('.petal-addon-check')) return;
      var pack = e.target.closest('.petal-pack');
      if (!pack || !page.contains(pack)) return;
      page.querySelectorAll('.petal-pack').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      pack.classList.add('is-selected');
      setTimeout(function () { try { pack.blur(); } catch (e) {} }, 0);
    });

    page.addEventListener('touchend', function (e) {
      var hit = e.target.closest('.petal-pack, .petal-accordion button, .petal-faq__question, .petal-atc, .petal-small-button, .petal-gallery__nav, .petal-belief__videobtn');
      if (!hit) return;
      setTimeout(function () { try { hit.blur(); } catch (err) {} }, 0);
    }, { passive: true });

    /* ---------- Addon checkbox (event-delegated) ---------- */
    function toggleAddon(el) {
      var checked = el.getAttribute('aria-checked') === 'true';
      el.setAttribute('aria-checked', checked ? 'false' : 'true');
      el.classList.toggle('is-checked');
    }
    page.addEventListener('click', function (e) {
      var el = e.target.closest('.petal-addon-check');
      if (!el || !page.contains(el)) return;
      e.stopPropagation();
      toggleAddon(el);
    });
    page.addEventListener('keydown', function (e) {
      var el = e.target.closest('.petal-addon-check');
      if (!el) return;
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        toggleAddon(el);
      }
    });

    /* ---------- Add to Cart ----------
       The selected pack carries a comma-separated list of variant IDs in
       data-petal-pack-variants. Any addons inside that pack with .is-checked
       contribute their data-addon-variant-id too. We POST all of them at once
       to /cart/add.js (Shopify's "items" array form), then dispatch a
       petal:cart:open event so the cart drawer shows itself with the new lines. */
    var atcBtn = page.querySelector('[data-petal-add-to-cart]');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        var pack = page.querySelector('.petal-pack.is-selected') || page.querySelector('.petal-pack');
        if (!pack) return;

        // Collect IDs: pack variants + checked addons inside the pack.
        // Also collect any discount codes from FREE addons so we can auto-apply
        // them after the cart-add succeeds.
        var ids = [];
        var discountCodes = [];
        var packVariants = (pack.getAttribute('data-petal-pack-variants') || '').split(',');
        packVariants.forEach(function (v) {
          v = (v || '').trim();
          if (v) ids.push(v);
        });
        pack.querySelectorAll('.petal-addon-check.is-checked').forEach(function (addon) {
          var v = (addon.getAttribute('data-addon-variant-id') || '').trim();
          if (v) ids.push(v);
          var code = (addon.getAttribute('data-addon-discount-code') || '').trim();
          var isFree = addon.getAttribute('data-addon-free') === '1';
          if (isFree && code && discountCodes.indexOf(code) === -1) {
            discountCodes.push(code);
          }
        });

        // Pack-level FREE partner: the partner variant is part of
        // data-petal-pack-variants (added at full price), so auto-apply the
        // pack's discount code to zero it out at checkout — same mechanism as
        // FREE addons.
        var packFreeCode = (pack.getAttribute('data-pack-discount-code') || '').trim();
        if (pack.getAttribute('data-pack-free') === '1' && packFreeCode && discountCodes.indexOf(packFreeCode) === -1) {
          discountCodes.push(packFreeCode);
        }

        // Deduplicate while collapsing repeats into quantity entries. No line
        // item properties — that would break Shopify's natural merge of the
        // same variant added twice into a single line at qty=2. Instead we
        // track insertion order client-side in sessionStorage (see below).
        var qtyByVariant = {};
        ids.forEach(function (v) {
          qtyByVariant[v] = (qtyByVariant[v] || 0) + 1;
        });
        var items = Object.keys(qtyByVariant).map(function (v) {
          return { id: parseInt(v, 10), quantity: qtyByVariant[v] };
        });

        // Record per-variant insertion order in sessionStorage so the cart
        // drawer can render in stable add-time order even when Shopify shifts
        // line indices around (e.g., addon-already-in-cart bumping). New
        // variants get a new sequence number; existing entries keep theirs.
        try {
          var orderMap = {};
          try { orderMap = JSON.parse(sessionStorage.getItem('petal_cart_order') || '{}') || {}; } catch (e) {}
          var maxSeq = 0;
          for (var k in orderMap) { if (orderMap[k] > maxSeq) maxSeq = orderMap[k]; }
          ids.forEach(function (v) {
            if (orderMap[v] === undefined) {
              maxSeq += 1;
              orderMap[v] = maxSeq;
            }
          });
          sessionStorage.setItem('petal_cart_order', JSON.stringify(orderMap));
        } catch (e) {}
        if (!items.length) {
          console.warn('[petal] No variant IDs available on selected pack — check the section settings.');
          return;
        }

        var originalLabel = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          atcBtn.disabled = false;
          atcBtn.textContent = originalLabel;
          if (!res.ok) {
            console.warn('[petal] /cart/add.js failed', res.data);
            atcBtn.textContent = (res.data && res.data.description) || 'Couldn’t add — try again';
            setTimeout(function () { atcBtn.textContent = originalLabel; }, 2400);
            return;
          }
          // Stash the codes synchronously so the cart drawer can re-apply
          // them on subsequent visits. Stored as a comma-separated list.
          try {
            var existing = (sessionStorage.getItem('petal_discount_codes') || '').split(',').filter(Boolean);
            discountCodes.forEach(function (c) {
              if (existing.indexOf(c) === -1) existing.push(c);
            });
            sessionStorage.setItem('petal_discount_codes', existing.join(','));
          } catch (e) {}

          // Open the cart drawer immediately on a successful add. We do NOT
          // wait for the discount-code cookies to be set — that work runs in
          // the background below and the cookie will be in place well before
          // the customer hits checkout. Blocking the drawer-open on a 302
          // round-trip per code was adding ~1.5s of perceived latency on the
          // bundle pack (the only one with FREE addons).
          document.dispatchEvent(new CustomEvent('petal:cart:open'));

          // Background: auto-apply any discount codes attached to FREE addons
          // via a hidden iframe. /discount/CODE 302s and sets the cookie on
          // that response. fetch() with redirect:'manual' is flaky for cookie
          // setting in modern browsers, so iframe is the reliable path.
          function applyOne(code) {
            return new Promise(function (resolve) {
              var iframe = document.createElement('iframe');
              iframe.setAttribute('aria-hidden', 'true');
              iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
              var done = false;
              function finish() {
                if (done) return;
                done = true;
                try { iframe.parentNode && iframe.parentNode.removeChild(iframe); } catch (e) {}
                resolve();
              }
              iframe.addEventListener('load', finish);
              // 600ms is enough for a 302 + tiny cart-page render in an iframe.
              // Acts only as a safety net since the drawer is no longer waiting.
              setTimeout(finish, 600);
              iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart?petal_applied=' + code);
              document.body.appendChild(iframe);
            });
          }
          var applyChain = Promise.resolve();
          discountCodes.forEach(function (code) {
            applyChain = applyChain.then(function () { return applyOne(code); });
          });
        })
        .catch(function (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = originalLabel;
          console.warn('[petal] cart add error', err);
        });
      });
    }

    /* ---------- Accordions (event-delegated, smooth max-height anim) ----------
       Open: measure scrollHeight, pin as inline max-height. Leave it pinned —
       clearing it would fall back to the base CSS max-height: 0 and trigger a
       second transition that retracts the body and clips the text.
       Close: re-pin current scrollHeight, force reflow, animate back to 0. */
    page.addEventListener('click', function (e) {
      var btn = e.target.closest('.petal-accordion button');
      if (!btn) return;
      var acc = btn.closest('.petal-accordion');
      if (!acc) return;
      var body = acc.querySelector('.petal-accordion__body');
      if (!body) return;
      var isOpen = acc.classList.contains('is-open');
      if (isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.offsetHeight; // commit so the next change animates
        body.style.maxHeight = '0px';
        acc.classList.remove('is-open');
      } else {
        acc.classList.add('is-open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });

    /* ---------- Gallery thumbs + arrows (filmstrip slide) ----------
       The track holds the current image. For an arrow click we insert the
       incoming image next to it (right for "next", left for "prev"), then
       translate the whole track so both images move together as one unit.
       After the transition we drop the old image and reset the track to 0.
       Boundaries: prev disabled at index 0, next disabled at last index. */
    var track = page.querySelector('[data-petal-track]');
    var mainImage = page.querySelector('[data-petal-main-image]');
    var prevBtn = page.querySelector('[data-petal-gallery-prev]');
    var nextBtn = page.querySelector('[data-petal-gallery-next]');
    var slideLock = false;
    var SLIDE_MS = 450;

    function petalGetThumbs() {
      return page.querySelectorAll('[data-petal-gallery-thumb]');
    }

    function petalActiveIndex() {
      var thumbs = petalGetThumbs();
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function petalUpdateArrowState() {
      var thumbs = petalGetThumbs();
      if (!thumbs.length) return;
      var idx = petalActiveIndex();
      if (prevBtn) prevBtn.setAttribute('aria-disabled', idx <= 0 ? 'true' : 'false');
      if (nextBtn) nextBtn.setAttribute('aria-disabled', idx >= thumbs.length - 1 ? 'true' : 'false');
    }

    function petalSetActiveThumb(target) {
      petalGetThumbs().forEach(function (item) {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });
      if (target) {
        target.classList.add('is-active');
        target.setAttribute('aria-current', 'true');
      }
      petalUpdateArrowState();
    }

    function petalInstantSwap(thumb) {
      if (!thumb || !mainImage || !thumb.dataset.petalImage) return;
      mainImage.src = thumb.dataset.petalImage;
      mainImage.alt = thumb.dataset.petalAlt || mainImage.alt;
      petalSetActiveThumb(thumb);
    }

    function petalSlideTo(thumb, direction) {
      if (!thumb || !mainImage || !track || !thumb.dataset.petalImage) return;
      if (slideLock) return;
      slideLock = true;

      var incoming = document.createElement('img');
      incoming.className = 'petal-gallery__photo';
      incoming.src = thumb.dataset.petalImage;
      incoming.alt = thumb.dataset.petalAlt || mainImage.alt;
      incoming.loading = 'eager';

      // Position the incoming image in the track on the side it's coming from.
      // Then animate the track so current + incoming drift together.
      track.style.transition = 'none';
      if (direction > 0) {
        track.appendChild(incoming);                 // [current, incoming]
        track.style.transform = 'translateX(0)';
      } else {
        track.insertBefore(incoming, mainImage);     // [incoming, current]
        track.style.transform = 'translateX(-100%)'; // start with current visible
      }
      // Force reflow so the starting transform is committed before we transition
      void track.offsetWidth;

      track.style.transition = 'transform ' + SLIDE_MS + 'ms cubic-bezier(.22, .61, .36, 1)';
      track.style.transform = direction > 0 ? 'translateX(-100%)' : 'translateX(0)';

      function finish() {
        track.removeEventListener('transitionend', onEnd);
        // Drop the outgoing image, reset the track to 0 with no transition,
        // and promote the incoming image to be the new "main".
        mainImage.parentNode && mainImage.parentNode.removeChild(mainImage);
        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        incoming.setAttribute('data-petal-main-image', '');
        mainImage = incoming;
        petalSetActiveThumb(thumb);
        slideLock = false;
      }
      function onEnd(ev) {
        if (ev.propertyName !== 'transform') return;
        finish();
      }
      track.addEventListener('transitionend', onEnd);
      // Safety net in case transitionend doesn't fire (e.g. tab inactive)
      setTimeout(function () { if (slideLock) finish(); }, SLIDE_MS + 80);
    }

    page.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-petal-gallery-thumb]');
      if (thumb) { petalInstantSwap(thumb); return; }

      var prevHit = e.target.closest('[data-petal-gallery-prev]');
      var nextHit = e.target.closest('[data-petal-gallery-next]');
      if (!prevHit && !nextHit) return;
      e.preventDefault();

      var btn = prevHit || nextHit;
      if (btn.getAttribute('aria-disabled') === 'true') return;

      var thumbs = petalGetThumbs();
      if (!thumbs.length) return;
      var idx = petalActiveIndex();
      var direction = nextHit ? 1 : -1;
      var targetIdx = idx + direction;
      if (targetIdx < 0 || targetIdx >= thumbs.length) return; // hard boundary
      petalSlideTo(thumbs[targetIdx], direction);
    });

    petalUpdateArrowState();

    /* ---------- Thumbnail strip scroll arrows ---------- */
    var thumbStrip = page.querySelector('.petal-gallery__thumbs');
    var thumbArrowL = page.querySelector('.petal-thumb-arrow--left');
    var thumbArrowR = page.querySelector('.petal-thumb-arrow--right');
    if (thumbStrip && thumbArrowL && thumbArrowR) {
      var scrollAmt = function() {
        var thumb = thumbStrip.querySelector('.petal-thumb');
        return thumb ? thumb.offsetWidth + 9 : 100;
      };
      thumbArrowL.addEventListener('click', function() {
        thumbStrip.scrollBy({ left: -scrollAmt() * 2, behavior: 'smooth' });
      });
      thumbArrowR.addEventListener('click', function() {
        thumbStrip.scrollBy({ left: scrollAmt() * 2, behavior: 'smooth' });
      });
    }

    /* ---------- Stats reveal + count-up ----------
       Bell-curve easing (ease-in-out cubic) so the count starts gently, runs
       through the middle, and decelerates into the target — matching the ring
       fill animation's cubic-bezier(.65, 0, .35, 1) timing. */
    function animateCount(el, target, duration, suffix, prefix) {
      suffix = suffix || '';
      prefix = prefix || '';
      var startTime = null;
      function step(t) {
        if (!startTime) startTime = t;
        var p = Math.min((t - startTime) / duration, 1);
        var eased = p < 0.5
          ? 4 * p * p * p
          : 1 - Math.pow(-2 * p + 2, 3) / 2;
        var v = Math.round(target * eased);
        el.textContent = prefix + v + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    /* Each stat card animates independently when it enters the viewport.
       Adding .is-visible to the card both triggers the CSS ring-fill animation
       and runs the count-up. Fixed slow duration (2400ms) — matches the CSS. */
    var STAT_FILL_MS = 2400;

    function fireStatCard(card) {
      if (!card || card.classList.contains('is-visible')) return;
      card.classList.add('is-visible');
      var el = card.querySelector('[data-petal-stat-target]');
      if (!el) return;
      var target = parseFloat(el.getAttribute('data-petal-stat-target')) || 0;
      var suffix = el.getAttribute('data-petal-stat-suffix') || '';
      var prefix = el.getAttribute('data-petal-stat-prefix') || '';
      el.textContent = prefix + '0' + suffix;
      animateCount(el, target, STAT_FILL_MS, suffix, prefix);

      /* Mellowsleep.com-style: set the SVG progress circle's stroke-dashoffset
         inline to the target value. The CSS rule on .petal-stat-ring__progress
         has `transition: stroke-dashoffset 2.4s cubic-bezier(...)`, so the
         browser smoothly tweens between the initial 100 (empty) and the
         target (e.g. 25 for a 75% fill). pathLength=100 is set on the circle
         so values map 1:1 with percentages. */
      var ring = card.querySelector('.petal-stat-ring__progress');
      if (ring) {
        // Force a starting value of 100 and a reflow so the transition picks
        // up the change even if the browser already painted the element.
        ring.style.strokeDashoffset = '100';
        // eslint-disable-next-line no-unused-expressions
        ring.getBoundingClientRect();
        requestAnimationFrame(function () {
          ring.style.strokeDashoffset = String(Math.max(0, 100 - target));
        });
      }
    }

    function observeStatCard(card) {
      if (!card) return;
      // Theme editor: fire immediately so the user can see the animation
      // without scrolling.
      if (window.Shopify && window.Shopify.designMode) {
        fireStatCard(card);
        return;
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            fireStatCard(entry.target);
            obs.unobserve(entry.target);
          });
        }, { threshold: 0.4 });
        observer.observe(card);
      } else {
        fireStatCard(card);
      }
    }

    document.querySelectorAll('.petal-stat-card').forEach(observeStatCard);

    /* Theme editor: re-attach observers when the section reloads (settings
       change) or is selected — the old DOM nodes are replaced. */
    function reinitStats(e) {
      var root = e && e.target && e.target.querySelectorAll ? e.target : document;
      root.querySelectorAll('.petal-stat-card').forEach(observeStatCard);
    }
    document.addEventListener('shopify:section:load', reinitStats);
    document.addEventListener('shopify:section:select', reinitStats);
  });
})();
